import vinesh from "./teamPhotos/Vinesh.jpg";
import yuvi from "./teamPhotos/Yuvi.png";
import rishi from "./teamPhotos/Rishi.png";
import kofi from "./teamPhotos/Kofi.jpg";
import tej from "./teamPhotos/Tej.JPEG";
import reich from "./teamPhotos/Reich.png";
import zayan from "./teamPhotos/Zayan.png";
import dev from "./teamPhotos/Dev.jpg";
import aadi from "./teamPhotos/Aadi.JPG";

const teamMembers = [
  {
    name: "Vinesh Ranganathan",
    image: vinesh,
    education: "Computer Science, Western University",
    funFacts: [
      "I play the drums",
      "My favourite coding language is SQL",
      "I have a dog named Kiba, she's a Shiba Inu and she's five years old. Kiba really likes apples.",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/vinesh-ranganathan/",
      instagram: "https://www.instagram.com/vinranga._/",
    },
  },
  {
    name: "Tejveer Saluja",
    image: tej,
    education: "Computer Science, Western University",
    funFacts: [
      "I love cars",
      "I'm a Black belt in Karate",
      "I know Python, Java, React.js and CSS",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/tejveer-saluja",
      instagram: "https://www.instagram.com/tejslja/",
    },
  },
  {
    name: "Reich Kiambati",
    image: reich,
    education: "Computer Science, Western University",
    funFacts: [
      "Wrote my first program when I was 11",
      "Built a model rocket that lauched 200 feet",
      "Nationally ranked go karter in Kenya when I was 13",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/reichkiambati/",
      instagram: "https://www.instagram.com/_r.eich/",
    },
  },
  {
    name: "Dev Joshi",
    image: dev,
    education: "BMOS (Finance Specialization), Western University",
    funFacts: [
      "I love to play golf",
      "My favorite show is game of thrones",
      "LeBron James is my goat",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/dev-joshi-b895421ab/",
      instagram: "https://www.instagram.com/devv.jjoshi/",
    },
  },
  {
    name: "Anokye Kofi Boateng",
    image: kofi,
    education: "Commerce, McMaster University",
    funFacts: [
      "Financial Risk Management Intern at KPMG",
      "Operated a Lawn Care company which recieved Ontario Summer Company funding.",
      "Enjoys working out",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/anokye-kofi-boateng/",
      instagram: "https://www.instagram.com/akofiboateng/",
    },
  },
  {
    name: "Rishi Jogia",
    image: rishi,
    education: "Computer Science, Western University",
    funFacts: [
      "I dont know how to swim",
      "My favourite drink is hot chocolate",
      "Born in Missisauga, Ontario",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/rishi-jogia/",
      instagram: "https://www.instagram.com/rishijogia/",
    },
  },
  {
    name: "Yuvraj Sharma",
    image: yuvi,
    education: "Computer Science, Western University",
    funFacts: ["Had 7 pets", "Knows 4 languages", "Avid lego collector"],
    socials: {
      linkedin: "https://www.linkedin.com/in/yuvraj-sharma-70940b317/",
      instagram: "https://www.instagram.com/yuvlsharma/",
    },
  },

  {
    name: "Zayan Khan",
    image: zayan,
    education: "Computer Science, Western University",
    funFacts: [
      "I love travelling around the world.",
      "I love to play Golf.",
      "I enjoy working out.",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/zayan-khan-2421b9210/",
      instagram: "https://www.instagram.com/_zayvnk/",
    },
  },
  {
    name: "Aadi Sanghvi",
    image: aadi,
    education: "Computer Science, Western University",
    funFacts: [
      "I know how to program in Python, Java, HTML, CSS and some Kotlin.",
      "I’m also a developer for Western Cyber Society.",
      "I like reading and watching shows when I’m not coding or studying.",
    ],
    socials: {
      linkedin: "https://www.linkedin.com/in/aadi-s-8441b926b/",
      instagram: "https://www.instagram.com/asang06/",
    },
  },
];

export default teamMembers;
